/*
 * @Author: wblijinyang
 * @FilePath: /mall-fe/src/libs/contexts/ProductListNetPrice.tsx
 * @Description: 商品列表查询网价context
 */
import { createContext, useContext, useState, useCallback } from 'react';
import { apiGetSkuAgreementPriceForList, apiGetAvailableSkuAgreement } from 'api/mall';
import useAreaCookie from 'hooks/useAreaCookie';

const ProductListNetPriceContext = createContext(null);
const NetActionPriceContext = createContext(null);

const ProductListNetPriceContextProvider = ({ children }) => {
  const [ProductListNetPrice, setProductListNetPrice] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getCookieAreaCode } = useAreaCookie();
  const getNetPriceList = useCallback(async (productList, setStateCallBack) => {
    try {
      let list = [...(productList || [])];
      const res = await apiGetAvailableSkuAgreement({
        json: {
          areaLevelCode: getCookieAreaCode(),
          mallSkuAvailableAgreementListParamList: list.map((item) => ({
            skuSysNo: item.bestSkuSysNo,
            tradeAgreementSysNoList: item.agreementSysNoList,
            tradeAgreementScopeList: item.tradeAgreementScopeList,
            templateTradeAgreementSysNoList: item.newAgreementSysNoList,
          })),
        },
      });
      if (res?.data?.length) {
        res?.data?.forEach((v) => {
          let item = list.find((val) => val.bestSkuSysNo === v.skuSysNo);
          if (item) {
            item.hasTradeAgreementFlag = v.hasTradeAgreementFlag;
            item.searchPriceFlag = v.searchPriceFlag;
            item.tradeAgreementSysNoToPrice = v.tradeAgreementSysNoToPrice;
          }
        });
        setStateCallBack(list);
      }
      const mallSkuAgreementParamList = list
        // ?.filter((v) => v.tradeAgreementSysNoToPrice && searchPriceFlag)
        ?.filter((v) => v.tradeAgreementSysNoToPrice && v.searchPriceFlag)
        ?.map((v) => ({
          skuSysNo: v.bestSkuSysNo,
          materialCategorySysNos: v.materialCategorySysNos && v.materialCategorySysNos[0],
          skuAttributeEntityList: v.attributeList,
          brandSysNo: v.brandSysNo,
          materialCategoryFullPathSysNoList: v.materialCategorySysNos,
          salesPrice: v.lowestPrice,
          tradeAgreementSysNo: v.tradeAgreementSysNoToPrice,
          taxRate: v.taxRate,
        }));
      if (!mallSkuAgreementParamList?.length) {
        setLoading(false);
        return;
      }
      setLoading(true);
      const { data } = await apiGetSkuAgreementPriceForList({
        json: {
          areaCode: getCookieAreaCode(),
          mallSkuAgreementParamList,
        },
      });
      setProductListNetPrice(data);
    } catch (err) {}
    setLoading(false);
  }, []);
  return (
    <ProductListNetPriceContext.Provider value={{ ProductListNetPrice, loading }}>
      <NetActionPriceContext.Provider value={getNetPriceList}>
        {children}
      </NetActionPriceContext.Provider>
    </ProductListNetPriceContext.Provider>
  );
};

const useProductListNetPriceContext = () => {
  const context = useContext(ProductListNetPriceContext);
  if (context === undefined) {
    throw new Error(
      'useProductListNetPriceContext must be used within a ProductListNetPriceContextProvider',
    );
  }
  return context;
};
const useNetActionPriceContext = () => {
  const context = useContext(NetActionPriceContext);
  if (context === undefined) {
    throw new Error('useNetActionPriceContext must be used within a NetActionPriceContext');
  }
  return context;
};
export {
  ProductListNetPriceContextProvider,
  useProductListNetPriceContext,
  useNetActionPriceContext,
};
